module.exports = __webpack_public_path__ + "static/media/toolbar-move.ce5b8151.svg";